<template>
  <v-dialog v-model="dialog" width="620px">
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>CHỈNH SỬA NHÓM KHOẢN LƯƠNG</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-form ref="form" flat class="pa-6 mb-10" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="title"
              label="Nhóm khoản lương"
              placeholder="Nhập nhóm khoản lương"
              outlined
              required
              dense
              class="required style"
              :rules="[$rules.required]"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="rank"
              label="Ưu tiên hiển thị"
              placeholder="Ưu tiên hiển thị"
              outlined
              dense
              class="style"
              :rules="[$rules.isNumber]"
            />
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions class="mt-5">
        <v-btn depressed outlined color="grey darken-1" class="px-6 ml-4 mt-n4 mb-2 white--text" @click="cancel">
          Hủy
        </v-btn>
        <v-spacer />
        <v-btn depressed color="primary" class="px-6 mr-4 mt-n4 mb-2 white--text" @click="save" :loading="loading">
          Lưu
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    state: Boolean
  },
  data() {
    return {
      valid: true,
      dialog: false,
      loading: false,
      title: '',
      category: 'custom',
      rank: null
    }
  },
  created() {
    this.initDatas()
  },
  computed: {
    ...mapState('salaryCollection', ['collection'])
  },
  methods: {
    ...mapActions('salaryCollection', ['updateCollection', 'fetchCollection']),
    cancel() {
      this.$refs.form.reset()
      this.dialog = false
    },
    initDatas() {
      this.title = this.collection && this.collection.title
      this.rank = this.collection && this.collection.rank
    },
    openDialog(id) {
      this.dialog = true
      try {
        this.fetchCollection(id)
      } catch (error) {
        this.$alert.error(error)
      }
    },
    validate() {
      return this.$refs.form.validate()
    },
    save() {
      if (this.validate()) {
        this.$dialog.confirm({
          title: 'Xác nhận chỉnh sửa?',
          text: 'Thao tác này sẽ ảnh hưởng đến hiển thị trên màn hình Tổng kết hoá đơn. Bạn muốn tiếp tục?',
          okText: 'Xác nhận',
          cancelText: 'Hủy',
          done: async () => {
            try {
              this.loading = true
              this.updateCollection({
                id: this.collection.id,
                data: { title: this.title, rank: this.rank }
              })
              this.$alert.updateSuccess('nhóm khoản lương')
              this.$refs.form.reset()
              this.dialog = false
              this.loading = false
            } catch (e) {
              this.$alert.error(e)
            }
          }
        })
      }
    }
  },
  watch: {
    collection() {
      this.initDatas()
    }
  }
}
</script>
<style lang="css" scoped>
h3 {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #212121;
}
.head_fee_title {
  margin: -10px 0;
}
.head_fee_title p {
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  color: #797979;
  margin: 15px 0 10px 0;
}
.head_fee_title h5 {
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #212121;
}
</style>
